<template>
  <div class="page-wrap" id="job-list-page">

    <!-- Processing overlay -->
    <transition name="fade">
      <div class="processing-overlay" v-if="loadingData">
        <div class="processing-overlay__box">
          <div class="processing-overlay__spinner"></div>
          <span>Loading jobs…</span>
        </div>
      </div>
    </transition>

    <div class="panel-card">
      <!-- Header -->
      <div class="panel-header">
        <div class="panel-header__icon">
          <i class="fa fa-briefcase"></i>
        </div>
        <div class="panel-header__text">
          <div class="panel-header__title">Mobile Service</div>
          <div class="panel-header__sub">Manage and track all mobile service jobs</div>
        </div>
        <div class="panel-header__action">
          <button class="btn-add" @click="JobCreate()">
            <i class="fa fa-plus"></i> Add Mobile Service
          </button>
        </div>
      </div>

      <!-- Filter bar -->
      <div class="filter-bar">
        <div class="filter-bar__field filter-bar__field--wide">
          <i class="fa fa-search filter-bar__icon"></i>
          <input
            type="text"
            class="filter-bar__input"
            placeholder="Search by job title, client name…"
            v-model="search_text"
            @keyup.enter="search()"
          />
        </div>
        <div class="ts-wrap" v-if="currentUser.u.is_admin" :class="{ open: spOpen }" v-click-outside="closeSpDropdown">
          <div class="ts-field" @click="toggleSp">
            <i class="fa fa-building ts-icon"></i>
            <input
              class="ts-input"
              ref="spInput"
              :value="spOpen ? spSearch : spLabel"
              @input="spSearch = $event.target.value"
              @mousedown.prevent
              placeholder="All Service Providers"
            />
            <i class="fa fa-chevron-down ts-arrow" :class="{ 'ts-arrow--open': spOpen }"></i>
          </div>
          <div class="ts-menu" v-if="spOpen">
            <div class="ts-opt" :class="{ 'ts-opt--sel': serviceProvider === 'all' }"
              @mousedown.prevent="selectSp('all')">All Service Providers</div>
            <div class="ts-opt" v-for="(sp, i) in filteredSp" :key="i"
              :class="{ 'ts-opt--sel': serviceProvider === sp.id }" @mousedown.prevent="selectSp(sp.id)">
              {{ sp.name }}</div>
            <div class="ts-empty" v-if="!filteredSp.length && spSearch">No matches</div>
          </div>
        </div>
        <div class="ts-wrap" v-if="!currentUser.u.is_client" :class="{ open: locOpen }" v-click-outside="closeLocDropdown">
          <div class="ts-field" @click="toggleLoc">
            <i class="fa fa-map-marker-alt ts-icon"></i>
            <input
              class="ts-input"
              ref="locInput"
              :value="locOpen ? locSearch : locLabel"
              @input="locSearch = $event.target.value"
              @mousedown.prevent
              placeholder="All Locations"
            />
            <i class="fa fa-chevron-down ts-arrow" :class="{ 'ts-arrow--open': locOpen }"></i>
          </div>
          <div class="ts-menu" v-if="locOpen">
            <div class="ts-opt" :class="{ 'ts-opt--sel': serviceOutlet === 'all' }"
              @mousedown.prevent="selectLoc('all')">All Locations</div>
            <div class="ts-opt" v-for="(citem, i) in filteredLoc" :key="i"
              :class="{ 'ts-opt--sel': serviceOutlet === citem.id }" @mousedown.prevent="selectLoc(citem.id)">
              {{ citem.name }}</div>
            <div class="ts-empty" v-if="!filteredLoc.length && locSearch">No matches</div>
          </div>
        </div>
        <div class="filter-bar__field">
          <select class="filter-bar__select" v-model="status">
            <option value="all">All Status</option>
            <option value="Open">Open</option>
            <option value="Closed">Closed</option>
            <option value="Deleted">Deleted</option>
          </select>
        </div>
        <button class="btn-search" @click="search()">
          <i class="fa fa-search"></i> Search
        </button>
      </div>

      <!-- Table -->
      <div class="table-wrap" v-if="getJobList.length > 0 && !loadingData" @click="activeMenu = null">
        <table class="job-table">
          <thead>
            <tr>
              <th class="th-num">#</th>
              <th>Job Title</th>
              <th>Schedule Date</th>
              <th v-if="temp_serviceOutlet == 'all'">Location / Service</th>
              <th>Client Name</th>
              <th>Phone</th>
              <th>Payment By</th>
              <th>Status</th>
              <th class="th-action"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(job, index) in getJobList" :key="index" class="job-row">
              <td class="td-num">{{ index + 1 }}</td>
              <td class="td-title">{{ job.title }}</td>
              <td>
                <span v-if="job.schedule_date">{{ job.schedule_date }}</span>
                <span v-else class="td-empty">—</span>
              </td>
              <td v-if="temp_serviceOutlet == 'all'">
                <div class="td-location">{{ job.location_name }}</div>
                <div class="td-service">{{ job.service_name }}</div>
              </td>
              <td>{{ job.client_name }}</td>
              <td>{{ job.client_phone_no }}</td>
              <td>{{ job.payment_by }}</td>
              <td>
                <span class="status-badge status-badge--open" v-if="job.status == 'Open'">Open</span>
                <span class="status-badge status-badge--closed" v-else>{{ job.status }}</span>
              </td>
              <td class="td-action">
                <div class="dot-menu" :class="{ 'dot-menu--open': activeMenu === index }">
                  <button class="dot-menu__trigger" @click.stop="toggleMenu(index, $event)">
                    <i class="fa fa-ellipsis-v"></i>
                  </button>
                  <div class="dot-menu__dropdown" v-if="activeMenu === index" :style="menuStyle">
                    <button
                      v-if="job.status !== 'Deleted' || currentUser.u.is_admin"
                      class="dot-menu__item"
                      @click="editJob(job); activeMenu = null"
                    >
                      <i class="fa fa-pen"></i> Edit
                    </button>
                    <button class="dot-menu__item" @click="viewdetails(job); activeMenu = null">
                      <i class="fa fa-eye"></i> Details
                    </button>
                    <button
                      v-if="currentUser.u.is_admin && job.status !== 'Deleted'"
                      class="dot-menu__item dot-menu__item--danger"
                      @click="confirmDeleteJob(job); activeMenu = null"
                    >
                      <i class="fa fa-trash"></i> Delete
                    </button>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Not searched yet (admin default) -->
      <div class="empty-state" v-if="!hasSearched && !loadingData">
        <i class="fa fa-filter empty-state__icon"></i>
        <div class="empty-state__title">Select filters and search</div>
        <div class="empty-state__sub">Choose a service provider or location, then click Search to load mobile service jobs</div>
      </div>

      <!-- Empty state -->
      <div class="empty-state" v-else-if="getJobList.length < 1 && !loadingData">
        <i class="fa fa-briefcase empty-state__icon"></i>
        <div class="empty-state__title">No jobs found</div>
        <div class="empty-state__sub">Try adjusting your filters or add a new mobile service job</div>
      </div>

      <!-- Pagination -->
      <div class="pagination-wrap" v-if="pagination.total_page > 1">
        <vl-pagination
          v-on:selected="selectedPage"
          v-on:previous="previousPage"
          v-on:first="firstPage"
          v-on:last="lastPage"
          v-on:next="nextPage"
          :pagination="pagination"
        ></vl-pagination>
      </div>
    </div>

    <!-- Delete confirm modal -->
    <div class="del-modal-overlay" v-if="delModal.show" @click.self="delModal.show = false">
      <div class="del-modal-box">
        <p>Delete <strong>{{ delModal.title }}</strong>? This job will be moved to Deleted status.</p>
        <div class="del-modal-actions">
          <button class="btn-cancel" @click="delModal.show = false">Cancel</button>
          <button class="btn-danger" @click="deleteJob()">Delete</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/mutations.type";
import {
  FETCH_CLIENT_JOB_LIST,
  FETCH_CLIENTS,
  GET_SERVICE_PROVIDER_LIST,
  DELETE_LOCATION_JOB,
} from "@/core/services/store/actions.type";
import vlPagination from "@/includes/table/Pagination";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      status: "all",
      serviceOutlet: "all",
      temp_serviceOutlet: "all",
      serviceProvider: "all",
      getJobList: [],
      search_text: "",
      offset: 0,
      limit: 10,
      activeMenu: null,
      menuStyle: null,
      pagination: {
        total_records: 0,
        total_page: 0,
        current_page: 1,
        per_page_data: 10,
        received_per_page_data: 10,
      },
      columns: [],
      url: "",
      loadingData: false,
      hasSearched: false,
      client_slug: this.$route.params.client_slug,
      msg: "",
      delModal: { show: false, id: null, title: "" },
      spOpen: false,
      spSearch: "",
      locOpen: false,
      locSearch: "",
      breadCrumbs: [
        { id: 1, title: "Dashboard", route: "client.dashboard" },
        { id: 2, title: "Mobile Service", route: "" },
      ],
    };
  },
  directives: {
    clickOutside: {
      bind(el, binding) {
        el._clickOutsideHandler = e => { if (!el.contains(e.target)) binding.value(e); };
        document.addEventListener("mousedown", el._clickOutsideHandler);
      },
      unbind(el) {
        document.removeEventListener("mousedown", el._clickOutsideHandler);
      }
    }
  },
  mounted() {
    this.$store.dispatch(FETCH_CLIENTS);
    if (this.currentUser.u.is_admin) {
      this.$store.dispatch(GET_SERVICE_PROVIDER_LIST);
    }
    this.serviceOutlet = this.currentUser.u.is_client ? "self" : "all";
    this.$store.commit(SET_BREADCRUMB, this.breadCrumbs);
    this.status = "all";
    if (!this.currentUser.u.is_admin) {
      this.jobData();
    }
    this.tablereset();
    this._closeMenu = () => { this.activeMenu = null; this.menuStyle = null; };
    document.addEventListener("click", this._closeMenu);
  },
  beforeDestroy() {
    document.removeEventListener("click", this._closeMenu);
  },
  components: {
    vlPagination,
  },
  computed: {
    ...mapGetters(["currentUser", "getClients", "getserviceProviders"]),
    mobileLocations() {
      return (this.getClients || []).filter(c => c.is_mobile_fingerprinting);
    },
    filteredSp() {
      const q = (this.spSearch || "").toLowerCase();
      return (this.getserviceProviders || []).filter(sp => !q || sp.name.toLowerCase().includes(q));
    },
    filteredLoc() {
      const q = (this.locSearch || "").toLowerCase();
      return this.mobileLocations.filter(c => !q || c.name.toLowerCase().includes(q));
    },
    spLabel() {
      if (this.serviceProvider === "all") return "";
      const found = (this.getserviceProviders || []).find(sp => sp.id === this.serviceProvider);
      return found ? found.name : "";
    },
    locLabel() {
      if (this.serviceOutlet === "all") return "";
      const found = this.mobileLocations.find(c => c.id === this.serviceOutlet);
      return found ? found.name : "";
    },
  },
  methods: {
    openSp() {
      this.spOpen = true;
      this.spSearch = "";
      this.$nextTick(() => this.$refs.spInput && this.$refs.spInput.focus());
    },
    toggleSp() {
      this.spOpen ? this.closeSpDropdown() : this.openSp();
    },
    closeSpDropdown() {
      this.spOpen = false;
      this.spSearch = "";
    },
    selectSp(id) {
      this.serviceProvider = id;
      this.closeSpDropdown();
    },
    openLoc() {
      this.locOpen = true;
      this.locSearch = "";
      this.$nextTick(() => this.$refs.locInput && this.$refs.locInput.focus());
    },
    toggleLoc() {
      this.locOpen ? this.closeLocDropdown() : this.openLoc();
    },
    closeLocDropdown() {
      this.locOpen = false;
      this.locSearch = "";
    },
    selectLoc(id) {
      this.serviceOutlet = id;
      this.closeLocDropdown();
    },
    search() {
      this.pagination = {
        total_records: 0,
        total_page: 0,
        current_page: 1,
        per_page_data: 10,
        received_per_page_data: 10,
      };
      this.jobData();
      this.tablereset();
    },
    selectedPage(n) {
      this.pagination.current_page = n;
      this.jobData();
    },
    nextPage() {
      this.pagination.current_page = this.pagination.current_page + 1;
      this.jobData();
    },
    lastPage() {
      this.pagination.current_page = this.pagination.total_page;
      this.jobData();
    },
    firstPage() {
      this.pagination.current_page = 1;
      this.jobData();
    },
    previousPage() {
      this.pagination.current_page = this.pagination.current_page - 1;
      this.jobData();
    },
    jobData() {
      this.getJobList = [];
      this.loadingData = true;
      this.hasSearched = true;
      var data = {
        service_outlet: this.serviceOutlet,
        service_provider: this.serviceProvider,
        user_type: this.currentUser.u.is_client
          ? "c"
          : this.currentUser.u.is_admin
          ? "admin"
          : "sp",
        status: this.status,
        page: this.pagination.current_page,
        search_text: this.search_text,
      };
      this.$store
        .dispatch(FETCH_CLIENT_JOB_LIST, data)
        .then((res) => {
          this.loadingData = false;
          this.getJobList = res.data;
          this.pagination.total_records = res.total_record;
          this.pagination.total_page = res.page_range;
          this.pagination.received_per_page_data = res.data.length;
          this.pagination.per_page_data = 10;
        })
        .catch((err) => {
          this.loadingData = false;
          this.msg = err.error;
        });
    },
    tablereset() {
      this.temp_serviceOutlet = this.serviceOutlet;
    },
    toggleMenu(index, event) {
      if (this.activeMenu === index) {
        this.activeMenu = null;
        this.menuStyle = null;
        return;
      }
      this.activeMenu = index;
      this.$nextTick(() => {
        const rect = event.currentTarget.getBoundingClientRect();
        const menuH = 170;
        const rightOffset = window.innerWidth - rect.right;
        if (window.innerHeight - rect.bottom < menuH + 8) {
          this.menuStyle = { position: "fixed", bottom: (window.innerHeight - rect.top + 4) + "px", top: "auto", right: rightOffset + "px" };
        } else {
          this.menuStyle = { position: "fixed", top: (rect.bottom + 4) + "px", bottom: "auto", right: rightOffset + "px" };
        }
      });
    },
    JobCreate() {
      if (this.currentUser.u.is_client) {
        this.$router.push({
          name: "client.job.form",
          params: {
            client_slug: this.client_slug,
            job_id: 0,
            client_id: this.currentUser.c.id,
          },
        });
      } else {
        this.$router.push({
          name: "client.job.form",
          params: {
            client_slug: this.client_slug,
            job_id: 0,
            client_id: this.serviceOutlet,
          },
        });
      }
    },
    editJob(job) {
      this.$router.push({
        name: "client.job.form",
        params: {
          client_slug: this.client_slug,
          job_id: job.id,
          client_id: job.client,
        },
      });
    },
    viewdetails(job) {
      this.$router.push({
        name: "client.job.details",
        params: {
          client_slug: this.client_slug,
          job_id: job.id,
          client_id: job.client,
        },
      });
    },
    confirmDeleteJob(job) {
      this.delModal = { show: true, id: job.id, title: job.title };
    },
    deleteJob() {
      this.$store
        .dispatch(DELETE_LOCATION_JOB, this.delModal.id)
        .then((data) => {
          this.$toastr.s(data.msg);
          this.delModal.show = false;
          this.jobData();
        })
        .catch((err) => {
          this.$toastr.e((err && err.msg) || "Failed to delete job");
          this.delModal.show = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
$font:   'Segoe UI', sans-serif;
$blue:   #389ad4;
$dark:   #0d1b3e;
$green:  #276749;
$border: #dde2ec;

/* ── overlay ── */
.processing-overlay {
  position: fixed;
  inset: 0;
  background: rgba(255,255,255,0.7);
  backdrop-filter: blur(3px);
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;

  &__box {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 14px;
    background: #fff;
    border: 1px solid $border;
    border-radius: 14px;
    padding: 32px 40px;
    box-shadow: 0 8px 32px rgba(0,0,0,0.1);
    font-family: $font;
    font-size: 13px;
    color: $dark;
    font-weight: 500;
  }

  &__spinner {
    width: 36px;
    height: 36px;
    border: 3.5px solid #c5d8f5;
    border-top-color: $blue;
    border-radius: 50%;
    animation: spin 0.7s linear infinite;
  }
}

@keyframes spin { to { transform: rotate(360deg); } }

.fade-enter-active, .fade-leave-active { transition: opacity 0.2s; }
.fade-enter, .fade-leave-to { opacity: 0; }

/* ── page wrap ── */
.page-wrap {
  padding: 12px;
  font-family: $font;
}

/* ── panel card ── */
.panel-card {
  background: #fff;
  border: 1px solid $border;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(0,0,0,0.05);
}

/* ── panel header ── */
.panel-header {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 20px 24px;
  border-bottom: 1px solid $border;
  background: linear-gradient(135deg, #f8faff 0%, #f0f5ff 100%);

  &__icon {
    width: 48px;
    height: 48px;
    border-radius: 12px;
    background: linear-gradient(135deg, $blue, #2277aa);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 18px;
    flex-shrink: 0;
  }

  &__text { flex: 1; }

  &__title {
    font-size: 16px;
    font-weight: 700;
    color: $dark;
    line-height: 1.2;
  }

  &__sub {
    font-size: 12px;
    color: #7a8499;
    margin-top: 3px;
  }

  &__action { flex-shrink: 0; }
}

.btn-add {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: $blue;
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 9px 18px;
  font-size: 13px;
  font-weight: 600;
  font-family: $font;
  cursor: pointer;
  transition: background 0.15s, box-shadow 0.15s;

  &:hover {
    background: #2d85bb;
    box-shadow: 0 4px 12px rgba(56,154,212,0.3);
  }
}

/* ── filter bar ── */
.filter-bar {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 16px 24px;
  border-bottom: 1px solid $border;
  flex-wrap: wrap;

  &__field {
    position: relative;
    display: flex;
    align-items: center;

    &--wide { flex: 1; min-width: 220px; }
  }

  &__icon {
    position: absolute;
    left: 11px;
    color: #a0aab8;
    font-size: 12px;
    pointer-events: none;
  }

  &__input {
    width: 100%;
    height: 38px;
    border: 1.5px solid $border;
    border-radius: 8px;
    padding: 0 12px 0 32px;
    font-size: 13px;
    font-family: $font;
    color: $dark;
    background: #fafbfd;
    outline: none;
    transition: border-color 0.15s, box-shadow 0.15s;

    &::placeholder { color: #b0bac9; }

    &:focus {
      border-color: $blue;
      box-shadow: 0 0 0 3px rgba(56,154,212,0.12);
      background: #fff;
    }
  }

  &__select {
    height: 38px;
    border: 1.5px solid $border;
    border-radius: 8px;
    padding: 0 32px 0 12px;
    font-size: 13px;
    font-family: $font;
    color: $dark;
    background: #fafbfd;
    outline: none;
    appearance: none;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8'%3E%3Cpath fill='%23a0aab8' d='M1 1l5 5 5-5'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: right 10px center;
    cursor: pointer;
    transition: border-color 0.15s;

    &:focus { border-color: $blue; }
  }
}

/* ── Type-and-select ── */
.ts-wrap {
  position: relative;
  min-width: 190px;
  max-width: 230px;
}

.ts-field {
  display: flex;
  align-items: center;
  height: 38px;
  border: 1.5px solid $border;
  border-radius: 8px;
  background: #fafbfd;
  padding: 0 10px;
  gap: 7px;
  cursor: pointer;
  transition: border-color 0.15s;

  .ts-wrap.open & {
    border-color: $blue;
    box-shadow: 0 0 0 3px rgba(56, 154, 212, 0.12);
    background: #fff;
  }
}

.ts-icon {
  font-size: 11px;
  color: #a0aab8;
  flex-shrink: 0;
}

.ts-input {
  flex: 1;
  border: none;
  outline: none;
  font-size: 13px;
  font-family: $font;
  color: $dark;
  background: transparent;
  min-width: 0;
  cursor: pointer;

  &::placeholder { color: #b0bac9; }
}

.ts-arrow {
  font-size: 10px;
  color: #a0aab8;
  flex-shrink: 0;
  transition: transform 0.2s;

  &--open { transform: rotate(180deg); }
}

.ts-menu {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  background: #fff;
  border: 1.5px solid $border;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(13, 27, 62, 0.1);
  z-index: 500;
  max-height: 240px;
  overflow-y: auto;
}

.ts-opt {
  padding: 8px 12px;
  font-size: 12.5px;
  color: $dark;
  cursor: pointer;
  transition: background 0.12s;

  &:hover { background: #f0f7fc; }

  &--sel { background: #eef7fb; color: $blue; font-weight: 600; }
}

.ts-empty {
  padding: 10px 12px;
  font-size: 12px;
  color: #a0aab8;
  text-align: center;
}

.btn-search {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 38px;
  background: $blue;
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 0 18px;
  font-size: 13px;
  font-weight: 600;
  font-family: $font;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.15s;

  &:hover { background: #2d85bb; }
}

/* ── table ── */
.table-wrap {
  overflow-x: auto;
  overflow-y: auto;
  max-height: 540px;
  padding: 0 24px 24px;
}

.job-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
  color: $dark;

  th {
    position: sticky;
    top: 0;
    z-index: 1;
    padding: 11px 14px;
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: #7a8499;
    border-bottom: 2px solid $border;
    white-space: nowrap;
    background: #fafbfd;
  }

  .th-num    { width: 40px; text-align: center; }
  .th-action { width: 40px; }

  td {
    padding: 11px 14px;
    border-bottom: 1px solid #f0f2f8;
    vertical-align: middle;
    white-space: nowrap;
  }

  .job-row {
    transition: background 0.12s;
    &:hover { background: #f8fbff; }
    &:last-child td { border-bottom: none; }
  }

  .td-num   { text-align: center; color: #a0aab8; font-size: 12px; }
  .td-title { white-space: normal; max-width: 200px; }
  .td-empty { color: #c0c8d8; }

  .td-location { font-weight: 400; font-size: 13px; color: $dark; white-space: normal; }
  .td-service  { font-size: 11.5px; color: #7a8499; margin-top: 2px; white-space: normal; }

  .td-action {
    text-align: right;
    padding-right: 12px;
  }
}

/* ── status badges ── */
.status-badge {
  display: inline-flex;
  align-items: center;
  padding: 3px 10px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.03em;

  &--open {
    background: #e6f4ec;
    color: $green;
  }
  &--closed {
    background: #fdecea;
    color: #b42318;
  }
}

/* ── 3-dot menu ── */
.dot-menu {
  position: relative;
  display: inline-flex;
  justify-content: flex-end;

  &__trigger {
    width: 30px;
    height: 30px;
    border: none;
    border-radius: 6px;
    background: transparent;
    color: #a0aab8;
    font-size: 14px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background 0.15s, color 0.15s;

    &:hover { background: #f0f3fa; color: $dark; }
  }

  &--open &__trigger {
    background: #f0f3fa;
    color: $dark;
  }

  &__dropdown {
    position: absolute;
    top: calc(100% + 4px);
    right: 0;
    background: #fff;
    border: 1.5px solid $border;
    border-radius: 10px;
    box-shadow: 0 6px 20px rgba(0,0,0,0.1);
    z-index: 50;
    min-width: 130px;
    overflow: hidden;
  }

  &__item {
    display: flex;
    align-items: center;
    gap: 8px;
    width: 100%;
    padding: 9px 14px;
    border: none;
    background: transparent;
    font-size: 13px;
    font-family: $font;
    color: $dark;
    cursor: pointer;
    text-align: left;
    transition: background 0.12s;

    &:hover { background: #f5f8ff; }

    i { font-size: 12px; color: #7a8499; width: 14px; }

    &--danger {
      color: #e53e3e;

      i { color: #e53e3e; }
      &:hover { background: #fff5f5; }
    }
  }
}

/* ── Delete confirm modal ── */
.del-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(13, 27, 62, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.del-modal-box {
  background: #fff;
  border-radius: 12px;
  width: 360px;
  max-width: 90vw;
  padding: 20px;
  box-shadow: 0 12px 40px rgba(13, 27, 62, 0.3);
  font-family: $font;

  p {
    font-size: 13px;
    color: $dark;
    margin-bottom: 16px;
  }
}

.del-modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.btn-cancel {
  height: 36px;
  padding: 0 18px;
  background: #fff;
  border: 1.5px solid $border;
  border-radius: 8px;
  color: #4a5568;
  font-size: 13px;
  font-weight: 600;
  font-family: $font;
  cursor: pointer;

  &:hover { border-color: #a0aab8; }
}

.btn-danger {
  height: 36px;
  padding: 0 18px;
  background: #e53e3e;
  border: none;
  border-radius: 8px;
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  font-family: $font;
  cursor: pointer;

  &:hover { opacity: 0.9; }
}

/* ── empty state ── */
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 56px 24px;
  gap: 10px;

  &__icon {
    font-size: 40px;
    color: #c5d0e0;
  }
  &__title {
    font-size: 15px;
    font-weight: 600;
    color: $dark;
  }
  &__sub {
    font-size: 13px;
    color: #7a8499;
  }
}

/* ── pagination ── */
.pagination-wrap {
  padding: 0 24px 20px;
  border-top: 1px solid $border;
  padding-top: 16px;
}
</style>
